/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { FC } from 'react';
import DataTableCell from '@salesforce/design-system-react/components/data-table/cell';
import IconSettings from '@salesforce/design-system-react/components/icon-settings';
import Dropdown from '@salesforce/design-system-react/components/menu-dropdown';

interface Props {
  children?: FC;
  item?: FileItem;
  handleAction: (option: any, id: string) => void;
}

interface FileItem {
  name: string;
}

const FileActionDataCell: FC<Props> = ({
  item = { name: '' },
  handleAction,
}) => {
  const { name } = item;
  return (
    <DataTableCell>
      <IconSettings iconPath="/icons">
        <span data-testid="attachment-action-btn">
          <Dropdown
            assistiveText={{ icon: 'More Options' }}
            menuPosition="overflowBoundaryElement"
            iconCategory="utility"
            iconName="down"
            iconVariant="border-filled"
            onSelect={(option: any): void => {
              handleAction(option, name);
            }}
            options={[
              { label: <span data-testid="attachment-delete">Delete</span>, value: 'del' },
            ]}
          />
        </span>
      </IconSettings>
    </DataTableCell>
  );
};

FileActionDataCell.displayName = DataTableCell.displayName;

export default FileActionDataCell;
